// The two static retention documents (blank forms) the GP reviews and signs
// with the patient at retainer delivery. Hosted on Google Drive; the shared
// PDFViewer proxies these /file/d/<id>/view links through the backend pdf-proxy.
export interface RetentionDocument {
    id: string;
    label: string;
    url: string;
}

export const RETENTION_DOCUMENTS: readonly RetentionDocument[] = [
    {
        id: 'doctor_retention_agreement',
        label: 'Doctor Facing Retention Agreement',
        url: 'https://drive.google.com/file/d/1f2EXc6WLfjm6EyQaqS-YoSfcf8T77zQO/view?usp=sharing'
    },
    {
        id: 'patient_retention_form',
        label: 'Patient Facing Retention Form',
        url: 'https://drive.google.com/file/d/1AFgPh1CHbgFI0wkerhWV1lVFPcBeFXiw/view?usp=sharing'
    }
];
